import z from "zod";
import type { FormInputSchemaParams } from "@/lib/types/form/form-field";

function extractOptionValue(value: unknown): string | undefined {
	if (typeof value === "string") return value;
	if (value && typeof value === "object" && "value" in value) {
		const option = value as { value?: unknown };
		return typeof option.value === "string" ? option.value : undefined;
	}
	return undefined;
}

export default function checkboxZodSchema({ required, type, options }: FormInputSchemaParams) {
	const allowedValues = (options ?? []).map((option) => option.value).filter((value): value is string => typeof value === "string");
	const allowedSet = new Set(allowedValues);
	const isSingle = type === "single";

	return z.any().superRefine((value, ctx) => {
		if (isSingle) {
			if (required && value !== true) {
				ctx.addIssue({ code: "custom", message: "required" });
				return;
			}
			if (value === null || value === undefined) return;
			if (typeof value !== "boolean") {
				ctx.addIssue({ code: "custom", message: "invalidCheckbox" });
			}
			return;
		}

		if (value === null || value === undefined) {
			if (required) {
				ctx.addIssue({ code: "custom", message: "required" });
			}
			return;
		}

		if (!Array.isArray(value)) {
			ctx.addIssue({ code: "custom", message: "invalidCheckboxMultiple" });
			return;
		}
		if (required && value.length === 0) {
			ctx.addIssue({ code: "custom", message: "required" });
			return;
		}

		const isValid = value.every((item) => {
			const optionValue = extractOptionValue(item);
			return typeof optionValue === "string" && allowedSet.has(optionValue);
		});

		if (!isValid) {
			ctx.addIssue({ code: "custom", message: "invalidCheckboxMultiple" });
		}
	});
}
